import { gql, useMutation, DocumentNode } from '@apollo/client';

const CREATE_USER_BORROWER_AND_LOAN: DocumentNode = gql`
  mutation CreateUserBorrowerAndLoan($input: OnboardBorrowerInput!) {
    createUserBorrowerAndLoan(onboardBorrowerInput: $input) {
      token
      loanId
    }
  }
`;

const CREATE_LOAN_WITH_OWNERSHIP: DocumentNode = gql`
  mutation CreateLoanWithOwnership($input: CreateLoanWithOwnershipInput!) {
    createLoanWithOwnership(createLoanWithOwnershipInput: $input) {
      token
      loanId
    }
  }
`;

const ONBOARD_BROKER: DocumentNode = gql`
  mutation OnboardBroker($input: OnboardBrokerInput!) {
    onboardBroker(onboardBrokerInput: $input) {
      token
      loanId
    }
  }
`;

export const useBorrowerOnboarding = () => {
  const [execute, { data, loading, error }] = useMutation(
    CREATE_USER_BORROWER_AND_LOAN,
    { fetchPolicy: 'no-cache' }
  );

  return {
    execute: (data: any) => execute({ variables: { input: data }}),
    data,
    fetching: loading,
    error
  };
};

export const useNewOwnershipOnboarding = () => {
  const [execute, { data, loading, error }] = useMutation(
    CREATE_LOAN_WITH_OWNERSHIP,
    { fetchPolicy: 'no-cache' }
  );

  return {
    execute: (data: any) => execute({ variables: { input: data }}),
    data,
    fetching: loading,
    error
  };
};

export const useBrokerOnboarding = () => {
  const [execute, { data, loading, error }] = useMutation(
    ONBOARD_BROKER,
    { fetchPolicy: 'no-cache' }
  );

  return {
    execute: (data: any) => execute({ variables: { input: data }}),
    data,
    fetching: loading,
    error
  };
};
